// src/utils/JobStatusHelper.js

export const JobStatusMap = {
    1: {
      label: 'В активном поиске',
      color: '#3D956F'
    },
    2: {
      label: 'Открыт для предложений',
      color: '#E6AF22'
    },
    3: {
      label: 'В медленном поиске',
      color: '#2277E6'
    },
    4: {
      label: 'Просто смотрю',
      color: '#E65122'
    }
  };
  
  export function getJobStatusData(statusId) {
    return JobStatusMap[statusId] || null;
  }